import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';


module.exports = {
    createFetchParams: (search, period) => ({
        search,
        state:      'all',
        start_date: Math.floor(period.startDate / TIMESTAMP_MULTIPLY),
        end_date:   Math.floor(period.endDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'monitoringHost',
        endpoint:           endpoints.monitoring.host,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: res => {
            res.results = res.results.map(item => ({
                name: item
            }));

            return res;
        }
    })
};




// WEBPACK FOOTER //
// ./src/modules/store/monitoringHost.js